import React from "react";

import { Tour } from "@amphore-dev/amphore-lib";
import { useTranslation } from "react-i18next";

import { useTour } from "@/hooks/useTour";

import { MOBILE_BREAKPOINT } from "@/constants/CConstants";

import { getIntroTourSteps } from "@/tours/intro/introTourSteps";

/**
 * The tour of the home page, shown once after the onboarding (or again
 * from the profile). Its targets are `data-tour` attributes on the
 * layout's menu / nav bar, the view switcher, the calendar and the
 * "new task" buttons.
 */
export const IntroTour: React.FC = () => {
	// Re-renders on languageChanged: the steps are rebuilt in the new one.
	useTranslation();
	const { open, finish } = useTour("intro");

	return (
		<Tour
			steps={getIntroTourSteps()}
			open={open}
			onClose={finish}
			mobileBreakpoint={MOBILE_BREAKPOINT}
			portal
		/>
	);
};
